const less = window.less;
export default less;